module.exports = __webpack_public_path__ + "static/smart_grouping-690676ce9d88019943d6799dbd8ca3a9.gif";